"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = settings;

var _actionTypes = require("../constants/actionTypes");

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initState = {
  emailSettings: {}
};

function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.LOAD_EMAIL_SETTINGS_REQUEST:
      return _objectSpread({}, state, _defineProperty({
        isLoading: true
      }, action.tableType, _objectSpread({}, state[action.tableType], {
        isLoading: true
      })));

    case _actionTypes.LOAD_EMAIL_SETTINGS_SUCCESS:
      return _objectSpread({}, state, _defineProperty({}, action.tableType, _objectSpread({}, state[action.tableType], {
        data: action.response.data,
        status: action.response.status,
        isLoading: false
      })));

    case _actionTypes.LOAD_EMAIL_SETTINGS_FAILURE:
      return _objectSpread({}, state, {}, initState, _defineProperty({}, action.tableType, {
        status: action.status ? action.status : 900,
        isLoading: false
      }));

    case _actionTypes.CHANGE_NOTIFICATION_STATUS_REQUEST:
    case _actionTypes.CHANGE_NOTIFICATION_STATUS_FAILURE:
    case _actionTypes.CHANGE_NOTIFICATION_STATUS_SUCCESS:
      return (0, _immutabilityHelper["default"])(state, _defineProperty({}, action.tableType, {
        $merge: {
          changeStatus: {
            isLoading: false
          }
        }
      }));

    case _actionTypes.SAVE_EMAIL_SETTINGS_REQUEST:
    case _actionTypes.SAVE_EMAIL_SETTINGS_SUCCESS:
      return (0, _immutabilityHelper["default"])(state, _defineProperty({}, action.tableType, {
        data: {
          items: _defineProperty({}, action.index, _defineProperty({}, action.field, {
            $set: action.newValue
          }))
        }
      }));

    case _actionTypes.SAVE_EMAIL_SETTINGS_FAILURE:
      return (0, _immutabilityHelper["default"])(state, _defineProperty({}, action.tableType, {
        data: {
          items: _defineProperty({}, action.index, _defineProperty({}, action.field, {
            $set: action.oldValue
          }))
        }
      }));

    default:
      return state;
  }
}